module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_frw_r1.htm"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_fm1_r1.htm"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p01_r1.htm"
    }
  }, [_vm._v("I THE MAGIC MOUNTAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c01_r1.htm"
    }
  }, [_vm._v("1. The Frozen Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c02_r1.htm"
    }
  }, [_vm._v("2. First Sight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c03_r1.htm"
    }
  }, [_vm._v("3. Reentry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c04_r1.htm"
    }
  }, [_vm._v("4. Tycoon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c05_r1.htm"
    }
  }, [_vm._v("5. Out of the Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c06_r1.htm"
    }
  }, [_vm._v("6. The Greening of Ganymede")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c07_r1.htm"
    }
  }, [_vm._v("7. Transit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c08_r1.htm"
    }
  }, [_vm._v("8. Starfleet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c09_r1.htm"
    }
  }, [_vm._v("9. Mount Zeus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c10_r1.htm"
    }
  }, [_vm._v("10. Ship of Fools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c11_r1.htm"
    }
  }, [_vm._v("11. The Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c12_r1.htm"
    }
  }, [_vm._v("12. Oom Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c13_r1.htm"
    }
  }, [_vm._v("13. “No One Told Us to Bring Swimsuits…”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c14_r1.htm"
    }
  }, [_vm._v("14. Search")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p02_r1.htm"
    }
  }, [_vm._v("II THE VALLEY OF BLACK SNOW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c15_r1.htm"
    }
  }, [_vm._v("15. Rendezvous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c16_r1.htm"
    }
  }, [_vm._v("16. Touchdown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c17_r1.htm"
    }
  }, [_vm._v("17. The Valley of Black Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c18_r1.htm"
    }
  }, [_vm._v("18. Old Faithful")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c19_r1.htm"
    }
  }, [_vm._v("19. At the End of the Tunnel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c20_r1.htm"
    }
  }, [_vm._v("20. Recall")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p03_r1.htm"
    }
  }, [_vm._v("III EUROPAN ROULETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c21_r1.htm"
    }
  }, [_vm._v("21. The Politics of Exile")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c22_r1.htm"
    }
  }, [_vm._v("22. Hazardous Cargo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c23_r1.htm"
    }
  }, [_vm._v("23. Inferno")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c24_r1.htm"
    }
  }, [_vm._v("24. Shaka the Great")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c25_r1.htm"
    }
  }, [_vm._v("25. The Shrouded World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c26_r1.htm"
    }
  }, [_vm._v("26. Night Watch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c27_r1.htm"
    }
  }, [_vm._v("27. Rosie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c28_r1.htm"
    }
  }, [_vm._v("28. Dialog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c29_r1.htm"
    }
  }, [_vm._v("29. Descent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c30_r1.htm"
    }
  }, [_vm._v("30. "), _c('em', [_vm._v("Galaxy")]), _vm._v(" Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c31_r1.htm"
    }
  }, [_vm._v("31. The Sea of Galilee")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p04_r1.htm"
    }
  }, [_vm._v("IV AT THE WATER HOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c32_r1.htm"
    }
  }, [_vm._v("32. Diversion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c33_r1.htm"
    }
  }, [_vm._v("33. Pit Stop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c34_r1.htm"
    }
  }, [_vm._v("34. Car Wash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c35_r1.htm"
    }
  }, [_vm._v("35. Adrift")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c36_r1.htm"
    }
  }, [_vm._v("36. The Alien Shore")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p05_r1.htm"
    }
  }, [_vm._v("V THROUGH THE ASTEROIDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c37_r1.htm"
    }
  }, [_vm._v("37. Star")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c38_r1.htm"
    }
  }, [_vm._v("38. Icebergs of Space")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c39_r1.htm"
    }
  }, [_vm._v("39. The Captain’s Table")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c40_r1.htm"
    }
  }, [_vm._v("40. Monsters from Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c41_r1.htm"
    }
  }, [_vm._v("41. Memoirs of a Centenarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c42_r1.htm"
    }
  }, [_vm._v("42. Minilith")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p06_r1.htm"
    }
  }, [_vm._v("VI HAVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c43_r1.htm"
    }
  }, [_vm._v("43. Salvage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c44_r1.htm"
    }
  }, [_vm._v("44. Endurance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c45_r1.htm"
    }
  }, [_vm._v("45. Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c46_r1.htm"
    }
  }, [_vm._v("46. Shuttle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c47_r1.htm"
    }
  }, [_vm._v("47. Shards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c48_r1.htm"
    }
  }, [_vm._v("48. Lucy")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p07_r1.htm"
    }
  }, [_vm._v("VII THE GREAT WALL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c49_r1.htm"
    }
  }, [_vm._v("49. Shrine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c50_r1.htm"
    }
  }, [_vm._v("50. Open City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c51_r1.htm"
    }
  }, [_vm._v("51. Phantom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c52_r1.htm"
    }
  }, [_vm._v("52. On the Couch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c53_r1.htm"
    }
  }, [_vm._v("53. Pressure Cooker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c54_r1.htm"
    }
  }, [_vm._v("54. Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c55_r1.htm"
    }
  }, [_vm._v("55. Magma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c56_r1.htm"
    }
  }, [_vm._v("56. Perturbation Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c57_r1.htm"
    }
  }, [_vm._v("57. Interlude on Ganymede")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p08_r1.htm"
    }
  }, [_vm._v("VIII THE KINGDOM OF SULFUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c58_r1.htm"
    }
  }, [_vm._v("58. Fire and Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c59_r1.htm"
    }
  }, [_vm._v("59. Trinity")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_p09_r1.htm"
    }
  }, [_vm._v("IX 3001")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_c60_r1.htm"
    }
  }, [_vm._v("60. Midnight in the Plaza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_ack_r1.htm"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_bm1_r1.htm"
    }
  }, [_vm._v("ADDENDUM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780795324857_epub_bm2_r1.htm"
    }
  }, [_vm._v("1996 POSTSCRIPT")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea4ef1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795324857_epub_toc_r1.vue
// module id = 66
// module chunks = 0